import React, { memo, useMemo } from 'react';
import { useAppSelector } from '../../../redux/app';
import { makeBidAskBySymbolSelector } from '../../../redux/selector';

const PriceCurrent = ({ type, digits, symbol }) => {
  const isType = {
    0: 'buy',
    1: 'sell',
    2: 'buy',
    3: 'sell',
    4: 'buy',
    5: 'sell',
    6: 'buy',
    7: 'sell'
  };

  if (isType[type] && isType[type].includes('buy')) {
    return <Bid symbol={symbol} digits={digits} />;
  }
  return <Ask symbol={symbol} digits={digits} />;
};

const Bid = memo(({ symbol, digits }) => {
  const tick = useAppSelector((state) => state?.stat?.tick);

  return <div className="text-xs text-[#9f9f9f]">{tick[symbol]?.bid?.toFixed(digits)}</div>;
});

Bid.displayName = 'Bid';

const Ask = memo(({ symbol, digits }) => {
  const tick = useAppSelector((state) => state?.stat?.tick);
  return <div className="text-xs text-[#9f9f9f]">{tick[symbol]?.ask?.toFixed(digits)}</div>;
});

Ask.displayName = 'Ask';

export default PriceCurrent;
